import Comment from './Comment.component';

export default Comment;